import { ref } from 'vue';

const EXAMPLE_CSV_URL = '/prompts/ANDERSONSTURFELITE_PLUS.csv';
const runRecommendationsAfterIngest = false; // set to false if you want to skip recommendations after ingest

export function useSoilIngest({ csrfToken, csrfParam }) {
	const loading = ref(false);
	const allSamples = ref([]);
	const lastOptimumRanges = ref({});
	const reportMeta = ref({});
	const validation = ref({});

	async function ingestFile(file, onSuccess) {
		const formData = new FormData();
		if (csrfParam && csrfToken) {
			formData.append(csrfParam, csrfToken);
		}
		formData.set('soil_test', file);

		reportMeta.value = {};
		validation.value = {};
		allSamples.value = [];
		lastOptimumRanges.value = {};
		loading.value = true;

		try {
			const res = await fetch('/actions/tnt/anthropic/ingest', {
				method: 'POST',
				body: formData
			});
			const data = await res.json();
			console.log('Ingest response:', data);
			loading.value = false;

			reportMeta.value = data.data.report_meta || {};
			validation.value = data.data.validation || {};
			allSamples.value = data.data.samples || [];
			lastOptimumRanges.value = data.data.optimum_ranges || {};

			if (onSuccess) onSuccess();

			if (!runRecommendationsAfterIngest) return;

			fetch('/actions/tnt/anthropic/recommend', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			})
				.then(res => res.json())
				.then(recommendations => {
					console.log('Recommendations:', recommendations);
					// renderRecommendationsPanel(recommendations);
				});
		} catch (error) {
			loading.value = false;
			console.error('Ingest request failed:', error);
			alert('Ingest failed. Check browser console and server logs for details.');
		}
	}

	async function loadExample(onSuccess) {
		loading.value = true;
		try {
			const res = await fetch(EXAMPLE_CSV_URL);
			if (!res.ok) throw new Error('HTTP ' + res.status);
			const blob = await res.blob();
			const file = new File([blob], 'ANDERSONSTURFELITE_PLUS.csv', { type: 'text/csv' });
			await ingestFile(file, onSuccess);
		} catch (error) {
			loading.value = false;
			console.error('Failed to load example CSV:', error);
			alert('Could not load the example file. Check browser console for details.');
		}
	}

	return { loading, allSamples, lastOptimumRanges, reportMeta, validation, ingestFile, loadExample };
}
